const HeaderMessages = {
  0: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        PUBLISH YOUR RESEARCH
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>The step listing on each section will guide you through the submission steps</li>
        <li>You cannot jump ahead or skip steps.</li>
        <li>You may review or revise any previously completed steps before completing your submission</li>
      </ul>
    </div>
  ),
  
  1: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Manuscript Files
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>On this page, you should upload your manuscript files.</li>
        <li>Please note that the <span className="font-semibold text-[--asfi-blue]">Main Manuscript File</span> and <span className="font-semibold text-[--asfi-blue]">Cover Letter</span> are mandatory.</li>
        <li>The Main Manuscript File can contain the manuscript texts, as well as the tables and figures. The tables and figures can also be uploaded as separate files. If including tables and figures in the Main Manuscript File, they should be placed after the list of references in the manuscript.</li>
        <li>The Main Manuscript and Table (if uploaded separately) files must be uploaded as a Word file.</li>
        <li>The Cover Letter and Supplementary files should be uploaded as PDF files.</li>
        <li>The Figure can be uploaded as PDF or picture file.</li>
        <li>The Point-by-Point Response to Reviewers (for revised manuscripts) and Main Manuscript File with Tracked Changes should be uploaded as PDF files.</li>
      </ul>
    </div>
  ),
  
  2: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Manuscript Title
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>Please provide a title for your manuscript, which should not be more than <span className="font-semibold text-[--asfi-blue]">20 words</span>.</li>
      </ul>
    </div>
  ),
  
  3: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Abstract
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>On this page, please provide the abstract for your manuscript.</li>
        <li>Please note that a <span className="font-semibold text-[--asfi-blue]">structured abstract</span> is required for Original Papers and Systematic Reviews. Other manuscript types can have an unstructured abstract.</li>
        <li>A structured abstract must have the following sections: <span className="font-medium text-gray-900">Background, Objective, Methods, Results, and Conclusion</span>.</li>
        <li>The maximum number of words for the abstract (structured or unstructured) must not exceed <span className="font-semibold text-[--asfi-blue]">300 words</span>.</li>
      </ul>
    </div>
  ),
  
  4: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Keywords
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>On this page, please provide <span className="font-semibold text-[--asfi-blue]">3-8 keywords</span> that best match the focus of your manuscript.</li>
        <li>The editorial office will use these to match appropriate subject matter experts for peer review.</li>
        <li>Since the keywords are used in indexing articles in different databases, please take careful considerations when selecting keywords for your manuscript.</li>
      </ul>
    </div>
  ),
  
  5: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Author's Information
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>On this page, please provide demographic information of all authors.</li>
        <li>You can also provide the <span className="font-semibold text-[--asfi-blue]">ORCID ID</span> for the authors that have it.</li>
        <li>Please ensure that the email addresses of all authors are correct.</li>
        <li>Please note that only one affiliation is required for each author, but you can include more than one affiliation for an author in the manuscript file.</li>
        <li>If you are currently an ASFI member, please include your <span className="font-semibold text-[--asfi-blue]">ASFI Membership ID</span>.</li>
      </ul>
    </div>
  ),
  
  6: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Suggest Reviewers <span className="text-sm font-normal text-gray-500">(Optional)</span>
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>Please suggest potential reviewers of your manuscript by providing their names, affiliations and emails.</li>
        <li>Please suggest at least <span className="font-semibold text-[--asfi-blue]">3 reviewers</span> and arrange them in the order of priority.</li>
      </ul>
    </div>
  ),
  
  7: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Disclosures
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>Please select all disclosures.</li>
      </ul>
    </div>
  ),
  
  8: (
    <div className="space-y-2">
      <span className="block text-sm font-semibold text-gray-800 ">
        Submission Preview
      </span>
      <ul className="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
        <li>This is the final stage of the submission process.</li>
        <li>On this page, all items you have inputted for your submission are displayed.</li>
        <li>Before clicking the <span className="font-semibold text-[--asfi-blue]">Submit</span> button, please carefully check to ensure that all items, including uploaded files, are correct.</li>
        <li>If anything is incorrect, you can use the navigation on the left to go back to the respective section and make the corrections.</li>
        <li>Once you are satisfied that all items are correct, please click the <span className="font-semibold text-[--asfi-blue]">Submit</span> button to submit the manuscript.</li>
        <li>Once the manuscript is submitted, all authors will receive a confirmation email.</li>
      </ul>
    </div>
  ),
};

// Optional: If you need to access messages by index with HTML string format for compatibility
export const HeaderMessagesAsHTML = {
  0: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">PUBLISH YOUR RESEARCH</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>The step listing on each section will guide you through the submission steps</li>
          <li>You cannot jump ahead or skip steps.</li>
          <li>You may review or revise any previously completed steps before completing your submission</li>
        </ul>
      </div>`,
  
  1: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">Manuscript Files</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>On this page, you should upload your manuscript files.</li>
          <li>Please note that the <span class="font-semibold text-[--asfi-blue]">Main Manuscript File</span> and <span class="font-semibold text-[--asfi-blue]">Cover Letter</span> are mandatory.</li>
          <li>The Main Manuscript File can contain the manuscript texts, as well as the tables and figures. The tables and figures can also be uploaded as separate files. If including tables and figures in the Main Manuscript File, they should be placed after the list of references in the manuscript.</li>
          <li>The Main Manuscript and Table (if uploaded separately) files must be uploaded as a Word file.</li>
          <li>The Cover Letter and Supplementary files should be uploaded as PDF files.</li>
          <li>The Figure can be uploaded as PDF or picture file.</li>
          <li>The Point-by-Point Response to Reviewers (for revised manuscripts) and Main Manuscript File with Tracked Changes should be uploaded as PDF files.</li>
        </ul>
      </div>`,
  
  2: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">Manuscript Title</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>Please provide a title for your manuscript, which should not be more than <span class="font-semibold text-[--asfi-blue]">20 words</span>.</li>
        </ul>
      </div>`,
  
  3: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">Abstract</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>On this page, please provide the abstract for your manuscript.</li>
          <li>Please note that a <span class="font-semibold text-[--asfi-blue]">structured abstract</span> is required for Original Papers and Systematic Reviews. Other manuscript types can have an unstructured abstract.</li>
          <li>A structured abstract must have the following sections: <span class="font-medium text-gray-900">Background, Objective, Methods, Results, and Conclusion</span>.</li>
          <li>The maximum number of words for the abstract (structured or unstructured) must not exceed <span class="font-semibold text-[--asfi-blue]">300 words</span>.</li>
        </ul>
      </div>`,
  
  4: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">Keywords</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>On this page, please provide <span class="font-semibold text-[--asfi-blue]">3-8 keywords</span> that best match the focus of your manuscript.</li>
          <li>The editorial office will use these to match appropriate subject matter experts for peer review.</li>
          <li>Since the keywords are used in indexing articles in different databases, please take careful considerations when selecting keywords for your manuscript.</li>
        </ul>
      </div>`,
  
  5: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">Author's Information</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>On this page, please provide demographic information of all authors.</li>
          <li>You can also provide the <span class="font-semibold text-[--asfi-blue]">ORCID ID</span> for the authors that have it.</li>
          <li>Please ensure that the email addresses of all authors are correct.</li>
          <li>Please note that only one affiliation is required for each author, but you can include more than one affiliation for an author in the manuscript file.</li>
          <li>If you are currently an ASFI member, please include your <span class="font-semibold text-[--asfi-blue]">ASFI Membership ID</span>.</li>
        </ul>
      </div>`,
  
  6: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">
          Suggest Reviewers <span class="text-sm font-normal text-gray-500">(Optional)</span>
        </span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>Please suggest potential reviewers of your manuscript by providing their names, affiliations and emails.</li>
          <li>Please suggest at least <span class="font-semibold text-[--asfi-blue]">3 reviewers</span> and arrange them in the order of priority.</li>
        </ul>
      </div>`,
  
  7: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">Disclosures</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>Please select all disclosures.</li>
        </ul>
      </div>`,
  
  8: `<div class="space-y-2">
        <span class="block text-sm font-semibold text-gray-800 ">Submission Preview</span>
        <ul class="list-disc text-sm list-inside space-y-1 text-gray-700 ml-2">
          <li>This is the final stage of the submission process.</li>
          <li>On this page, all items you have inputted for your submission are displayed.</li>
          <li>Before clicking the <span class="font-semibold text-[--asfi-blue]">Submit</span> button, please carefully check to ensure that all items, including uploaded files, are correct.</li>
          <li>If anything is incorrect, you can use the navigation on the left to go back to the respective section and make the corrections.</li>
          <li>Once you are satisfied that all items are correct, please click the <span class="font-semibold text-[--asfi-blue]">Submit</span> button to submit the manuscript.</li>
          <li>Once the manuscript is submitted, all authors will receive a confirmation email.</li>
        </ul>
      </div>`,
};

export default HeaderMessages;